import { Component, OnInit, Inject, Injector } from '@angular/core';
import { Patient } from 'app/core/interfaces/patient';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { addressI } from 'app/core/interfaces/adress';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { PatientPreviousEncounterDetails } from 'app/modules/practitioner/components/patient-previous-encounters-details/patient-previous-encounters-details';

@Component({
  selector: 'page-patient-details',
  templateUrl: './patient-details.component.html',
  styleUrls: ['./patient-details.component.scss'],
})
export class PractitionerPatientDetailsComponent extends BaseComponent implements OnInit {
  public patient: Patient = <Patient>{};
  public address: addressI = <addressI>{};
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];
  public checked = true;
  public patientGender: string = '';
  public previousEncounters: any[] = [];
  public pagedEncounters: any[] = [];
  public currentPage = 1;
  public itemsPerPage = 7;
  public totalPages = 0;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private encounterService: EncounterService
  ) {
    super(injector);
  }

  async ngOnInit() {
    if (this.data.param.patient) {
      this.patient = this.data.param.patient;
      this.address = this.data.param.patient.address;
      this.transformGender(this.data.param.patient.gender);
    }

    await this.getPatientPreviousConsultations();
  }

  async getPatientPreviousConsultations() {
    this.encounterService.listFinishedEncountersByPatient(this.patient.patient_id).subscribe({
      next: (resPreviousEncounters: any) => {
        this.previousEncounters = resPreviousEncounters;
        this.setupPagination();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  setupPagination() {
    this.totalPages = Math.ceil(this.previousEncounters.length / this.itemsPerPage);
    this.loadPage();
  }

  loadPage() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.pagedEncounters = this.previousEncounters.slice(startIndex, endIndex);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadPage();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPage();
    }
  }

  openPatientPreviousEncounterDetail(encounter: any) {
    const data = {
      title: `Dados do atendimento - ${encounter.encounter_id}`,
      param: {
        encounter: encounter,
        patient: this.patient,
      },
    };

    this.dialog.openComponentDialog(PatientPreviousEncounterDetails, data);
  }

  transformGender(genre: string) {
    switch (genre) {
      case 'male':
        this.patientGender = 'Masculino';
        return this.patientGender;
      default:
        this.patientGender = 'Feminino';
        return this.patientGender;
    }
  }

  formatPhone(value ?: string): string {
    if (!value) return '';
    let digits = String(value).replace(/\D/g, '');
    if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
    if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    return value;
  }
}
